/**
 * Image banner: mobile "Read more / Read less" truncation toggle.
 * Only active when the CSS clamp applies (mobile + text_bottom split layout);
 * on desktop or when the text fits, the button stays hidden.
 */
document.querySelectorAll(".image-banner__information").forEach(function (info) {
  var text = info.querySelector(".image-banner__text");
  var button = info.querySelector(".image-banner__read-more");
  if (!text || !button) return;

  var checkOverflow = function () {
    var expanded = text.classList.contains("is-expanded");
    var overflows = text.scrollHeight > text.clientHeight + 1;
    button.hidden = !(overflows || expanded);
  };

  button.addEventListener("click", function () {
    var expanded = text.classList.toggle("is-expanded");
    button.setAttribute("aria-expanded", expanded ? "true" : "false");
    checkOverflow();
  });

  checkOverflow();

  var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkOverflow, 150);
  });
});
